import { render, staticRenderFns } from "./PlannedTransactionViewCompact.vue?vue&type=template&id=24c66a94&scoped=true&"
import script from "./PlannedTransactionViewCompact.vue?vue&type=script&lang=js&"
export * from "./PlannedTransactionViewCompact.vue?vue&type=script&lang=js&"
import style0 from "./PlannedTransactionViewCompact.vue?vue&type=style&index=0&id=24c66a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c66a94",
  null
  
)

export default component.exports